export const MappingTypeEnum = {
  Language: 1,
  MealStatus: 2,
  CaseType: 3,
  Site: 4,
  Grade: 5
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/MappingTypeEnum.js